import React, { FC } from 'react';
import Box from '@mui/material/Box';

interface IHeaderProps {
  children?: React.ReactNode;
}

const Header: FC<IHeaderProps> = ({ children }) => {
  return (
    <Box
      id='global_header'
      sx={{
        width: 1,
        height: 56,
        backgroundColor: 'primary.main',
      }}
    >
      {children}
    </Box>
  );
};
export default Header;
